// extracted by mini-css-extract-plugin
module.exports = {"establishments":"Shipments_establishments__efYqg","header":"Shipments_header__3aMQP","tableHeader":"Shipments_tableHeader__2QRvo"};